module.exports = __webpack_public_path__ + "files/74b1de993c987119e1e7514dc2103d30.svg";